"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paginator = exports.Pagination = exports.PaginationLinks = exports.PaginationLinkLast = exports.PaginationLinkNext = exports.PaginationLinkPrev = exports.PaginationLinkFirst = exports.PaginationLink = exports.PaginationEllipsis = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function PaginationEllipsis(props) {
    return jsx_runtime_1.jsx("span", Object.assign({}, props, { children: "..." }), void 0);
}
exports.PaginationEllipsis = PaginationEllipsis;
function PaginationLink(_a) {
    var { onClick, disabled, active } = _a, props = tslib_1.__rest(_a, ["onClick", "disabled", "active"]);
    return (jsx_runtime_1.jsx("a", Object.assign({ href: "#", className: active ? "active" : "" }, props, { onClick: (event) => {
            event.preventDefault();
            !disabled && onClick && onClick(event);
        } }), void 0));
}
exports.PaginationLink = PaginationLink;
function PaginationLinkFirst(props) {
    return jsx_runtime_1.jsx(PaginationLink, Object.assign({}, props, { children: "<<" }), void 0);
}
exports.PaginationLinkFirst = PaginationLinkFirst;
function PaginationLinkPrev(props) {
    return jsx_runtime_1.jsx(PaginationLink, Object.assign({}, props, { children: "<" }), void 0);
}
exports.PaginationLinkPrev = PaginationLinkPrev;
function PaginationLinkNext(props) {
    return jsx_runtime_1.jsx(PaginationLink, Object.assign({}, props, { children: ">" }), void 0);
}
exports.PaginationLinkNext = PaginationLinkNext;
function PaginationLinkLast(props) {
    return jsx_runtime_1.jsx(PaginationLink, Object.assign({}, props, { children: ">>" }), void 0);
}
exports.PaginationLinkLast = PaginationLinkLast;
function PaginationLinks({ pageCount, currentPage, onChange, pageRangeDisplayed = 2, marginPagesDisplayed = 3, PaginationLinkComponent = PaginationLink, PaginationEllipsisComponent = PaginationEllipsis, }) {
    const items = [];
    const renderLink = (page) => (jsx_runtime_1.jsx(PaginationLinkComponent, Object.assign({ active: currentPage === page, disabled: currentPage === page, onClick: (event) => currentPage !== page && onChange(event, page) }, { children: page }), page));
    if (pageCount <= pageRangeDisplayed) {
        for (let index = 0; index < pageCount; index++) {
            items.push(renderLink(index + 1));
        }
        return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: items }, void 0);
    }
    let leftSide = pageRangeDisplayed / 2;
    let rightSide = pageRangeDisplayed - leftSide;
    // If the selected page index is on the default right side of the pagination,
    // we consider that the new right side is made up of it (= only one break element).
    // If the selected page index is on the default left side of the pagination,
    // we consider that the new left side is made up of it (= only one break element).
    if (currentPage > pageCount - pageRangeDisplayed / 2) {
        rightSide = pageCount - currentPage;
        leftSide = pageRangeDisplayed - rightSide;
    }
    else if (currentPage < pageRangeDisplayed / 2) {
        leftSide = currentPage;
        rightSide = pageRangeDisplayed - leftSide;
    }
    let index;
    let page;
    let breakView;
    for (index = 0; index < pageCount; index++) {
        page = index + 1;
        // If the page index is lower than the margin defined,
        // the page has to be displayed on the left side of
        // the pagination.
        if (page <= marginPagesDisplayed) {
            items.push(renderLink(page));
            continue;
        }
        // If the page index is greater than the page count
        // minus the margin defined, the page has to be
        // displayed on the right side of the pagination.
        if (page > pageCount - marginPagesDisplayed) {
            items.push(renderLink(page));
            continue;
        }
        // If the page index is near the selected page index
        // and inside the defined range (pageRangeDisplayed)
        // we have to display it (it will create the center
        // part of the pagination).
        if (index >= currentPage - leftSide && index <= currentPage + rightSide) {
            items.push(renderLink(page));
            continue;
        }
        // If the page index doesn't meet any of the conditions above,
        // we check if the last item of the current "items" array
        // is a break element. If not, we add a break element, else,
        // we do nothing (because we don't want to display the page).
        if (items[items.length - 1] !== breakView) {
            breakView = jsx_runtime_1.jsx(PaginationEllipsisComponent, {}, "break-view");
            items.push(breakView);
        }
    }
    return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: items }, void 0);
}
exports.PaginationLinks = PaginationLinks;
function Pagination({ currentPage, onChange, pageCount, pageRangeDisplayed, marginPagesDisplayed, PaginationLinkComponent, PaginationEllipsisComponent, PaginationLinkFirstComponent = PaginationLinkFirst, PaginationLinkPrevComponent = PaginationLinkPrev, PaginationLinkNextComponent = PaginationLinkNext, PaginationLinkLastComponent = PaginationLinkLast, }) {
    const handleFirstPage = (event) => {
        currentPage > 1 && onChange(event, 1);
    };
    const handlePreviousPage = (event) => {
        currentPage > 1 && onChange(event, currentPage - 1);
    };
    const handleNextPage = (event) => {
        currentPage < pageCount && onChange(event, currentPage + 1);
    };
    const handleLastPage = (event) => {
        currentPage < pageCount && onChange(event, pageCount);
    };
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(PaginationLinkFirstComponent, { onClick: handleFirstPage, disabled: currentPage < 2 }, void 0),
            jsx_runtime_1.jsx(PaginationLinkPrevComponent, { onClick: handlePreviousPage, disabled: currentPage < 2 }, void 0),
            jsx_runtime_1.jsx(PaginationLinks, { pageCount: pageCount, currentPage: currentPage, onChange: onChange, pageRangeDisplayed: pageRangeDisplayed, marginPagesDisplayed: marginPagesDisplayed, PaginationLinkComponent: PaginationLinkComponent, PaginationEllipsisComponent: PaginationEllipsisComponent }, void 0),
            jsx_runtime_1.jsx(PaginationLinkNextComponent, { onClick: handleNextPage, disabled: currentPage >= pageCount }, void 0),
            jsx_runtime_1.jsx(PaginationLinkLastComponent, { onClick: handleLastPage, disabled: currentPage >= pageCount }, void 0)] }, void 0));
}
exports.Pagination = Pagination;
function Paginator({ totalCount, perPage, onChange: defaultOnChange, currentPage: defaultCurrentPage, pageRangeDisplayed, marginPagesDisplayed, PaginationComponent = Pagination, }) {
    const pageCount = Math.round(totalCount / perPage) + (totalCount % perPage ? 1 : 0);
    const [currentPage, setCurrentPage] = react_1.useState(defaultCurrentPage);
    const onChange = (event, page) => {
        defaultOnChange(event, page);
        setCurrentPage(page);
    };
    return (jsx_runtime_1.jsx(PaginationComponent, { onChange: onChange, currentPage: currentPage, pageCount: pageCount, pageRangeDisplayed: pageRangeDisplayed, marginPagesDisplayed: marginPagesDisplayed }, void 0));
}
exports.Paginator = Paginator;
//# sourceMappingURL=Paginator.js.map